module.exports = __webpack_public_path__ + "static/media/108leonard-popup-full.2fbbd23a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/108leonard-popup-full.jpeg
// module id = 767
// module chunks = 0